export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	if (config.public.environment !== 'production') {
		console.warn(`You are in ${config.public.environment} mode`)
	}
})
